/**
 * Help modal used in various locations
 */
UserDocs.View.Modal.Help = Backbone.View.extend(
/** @lends UserDocs.View.Modal.Help# */
{
	/* the content to be used in the help modal. Should be set before calling render */
	content: null,
	
	/** 
	 * Creates a modal using the jQuery UI Modal library extension
	 * created for ELE and located in common/js/ele.modal.js
	 */
	render: function() {
		var dialog = ele.modal.create({
            content: $("<div />").append(this.content),
            dialogClass: "e_modal_help",
            draggable: true,
            width:600
		});
		dialog.dialog('open');
	}
	
});